import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import AltaIncidenciasPasos from './AltaIncidenciasPasos';
import AddIcon from '@mui/icons-material/Add';
import { useDispatch } from 'react-redux'
import { obtenerlotes } from '../../../Redux/LotesDucks';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DialogoContenidorRegistroInci() {
  const dispatch = useDispatch()
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = (event) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    dispatch(obtenerlotes())
  };

  return (
    <>
      <Button variant='contained' onClick={(event) => handleClickOpen()} color='success'>
        <AddIcon />  Registar incidencias
      </Button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }} color='info'>
          <Toolbar >
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Nueva incidencia
            </Typography>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <AltaIncidenciasPasos />


      </Dialog>
    </>
  );
}